import createIcon from '../../createIcon';

/**
 * @component @name CurrencyLira
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSA4Ljc2VjNIMTFWNy41MUwxNSA1VjcuMzZMMTEgOS44N0wxMS4wMSAxMi4yMkwxNSA5LjcyVjEyLjA4TDExIDE0LjU5VjE5QzEzLjc2IDE5IDE2IDE2Ljc2IDE2IDE0SDE4QzE4IDE3Ljg3IDE0Ljg3IDIxIDExIDIxSDlWMTUuODRMNiAxNy43MlYxNS4zNkw5IDEzLjQ4VjExLjEyTDYgMTNWMTAuNjRMOSA4Ljc2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CurrencyLira = createIcon('CurrencyLira', [
  [
    'path',
    {
      d: 'M9 8.76V3H11V7.51L15 5V7.36L11 9.87L11.01 12.22L15 9.72V12.08L11 14.59V19C13.76 19 16 16.76 16 14H18C18 17.87 14.87 21 11 21H9V15.84L6 17.72V15.36L9 13.48V11.12L6 13V10.64L9 8.76Z',
      key: 'i965ex',
    },
  ],
]);

export default CurrencyLira;
